/**
 * Instruction clipboard utilities - Copy/Paste instructions
 */

export function validateInstructionClipboard(data) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return { valid: false };
  }

  const instructions = [];
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    if (!item || typeof item !== 'object') {
      return { valid: false };
    }
    const value = item.value;
    if (value === undefined || value === null) {
      return { valid: false };
    }
    instructions.push({ text: String(value) });
  }
  return { valid: true, instructions };
}

export function parseInstructionClipboard(text) {
  if (!text || typeof text !== 'string' || !text.trim()) {
    return { valid: false };
  }
  try {
    const data = JSON.parse(text);
    return validateInstructionClipboard(data);
  } catch {
    return { valid: false };
  }
}

export function serializeInstructionsToClipboard(instructions) {
  if (!Array.isArray(instructions)) return '';

  const lines = instructions
    .filter(inst => inst && typeof inst.text === 'string')
    .map(inst => String(inst.text).trim())
    .filter(Boolean);

  return lines.join('\n');
}

/** Same text extraction Ctrl+V paste events use. */
export function extractTextFromClipboardData(clipboardData) {
  if (!clipboardData) return '';

  const plain =
    clipboardData.getData?.('text/plain') ??
    clipboardData.getData?.('text') ??
    '';
  if (String(plain).trim()) {
    return plain;
  }

  const html = clipboardData.getData?.('text/html') ?? '';
  if (!html || typeof document === 'undefined') {
    return '';
  }

  const container = document.createElement('div');
  container.innerHTML = html;
  return container.textContent ?? '';
}

export function shouldIgnoreInstructionDocumentPaste(target) {
  return Boolean(
    target instanceof HTMLElement &&
    target.closest('input, textarea, [contenteditable="true"]')
  );
}
